<template>
  <div class="-m-1 flex max-h-[26rem] flex-col gap-2" data-test="tendina-notifiche">
    <div class="flex items-center justify-between gap-2">
      <p class="text-sm font-semibold text-text-primary">{{ t("centro_notifiche.titolo") }}</p>
      <UiButton v-tooltip.top="t('centro_notifiche.azioni.segna_tutte')" variant="ghost" size="sm" icon="fal fa-check-double" :label="t('centro_notifiche.azioni.segna_tutte')" :disabled="!store.nonLette" data-test="notifiche-tutte-lette" @click="segnaTutte" />
    </div>
    <SegmentedControl v-model="filtro" :options="opzioni" :aria-label="t('centro_notifiche.filtro')" size="sm" full-width />
    <div class="-mr-2 min-h-0 flex-1 overflow-y-auto pr-2">
      <NotificheElenco :righe="dati?.righe ?? null" :filtro="filtro" :caricamento-iniziale="caricamentoIniziale" :errore="!!errore" :ritentando="ritentando" :adesso="adesso" @letta="(id) => void store.segnaLette([id])" @archivia="(id, archiviare) => void store.archivia([id], archiviare)" @apri="apriNotifica" @ritenta="ritenta" />
    </div>
    <NuxtLink to="/notifiche" class="interactive text-center text-sm font-medium text-text-accent underline-offset-2 hover:underline" data-test="notifiche-vedi-tutte" @click="emit('chiudi')">{{ t("centro_notifiche.vedi_tutte") }}</NuxtLink>
  </div>
</template>

<script setup lang="ts">
// Contenuto della tendina della campanella: le ultime notifiche con il filtro Tutte / Non lette, raggruppate per giorno. Si monta all'apertura (le richieste partono
// solo allora). «Vedi tutte» porta alla pagina `/notifiche`.
import { useI18n } from "vue-i18n";
import type { FiltroNotifiche, NotificaApi } from "~~/shared/data-model/notifica_api";
import { useNotificheAzioni } from "~/composables/useNotificheAzioni";

const emit = defineEmits<{ chiudi: [] }>();
const { t } = useI18n();
const store = useNotificheStore();
const filtro = ref<FiltroNotifiche>("tutte");
const righe = ref(15);
const opzioni = computed(() => [
  { value: "tutte", label: t("centro_notifiche.filtri.tutte") },
  { value: "non_lette", label: t("centro_notifiche.filtri.non_lette") },
]);
const { dati, errore, caricamentoIniziale, ritentando, ritenta } = useElencoNotifiche(filtro, righe);
const adesso = ref(new Date());
watch(dati, () => (adesso.value = new Date()));

const { segnaTutte, apriNotifica: apri } = useNotificheAzioni();
function apriNotifica(n: NotificaApi): void {
  emit("chiudi");
  void apri(n);
}
</script>
